// extracted by mini-css-extract-plugin
export var attachment = "_ot-a";
export var emailContainer = "_ot-4";
export var emailContentPaddedContainer = "_ot-b";
export var emailHeader = "_ot-6";
export var emailIframe = "_ot-3";
export var emailInfoIcon = "_ot-9";
export var emailShortenedSummary = "_ot-e";
export var infoDropdown = "_ot-0";
export var infoRowBoundedContent = "_ot-d";
export var internal = "_ot-5";
export var merchant = "_ot-8";
export var messageInputContainer = "_ot-h";
export var normal = "_ot-7";
export var replyCard = "_ot-f";
export var subtleButton = "_ot-1";
export var subtleButtonIconContainer = "_ot-2";
export var toggleViewRepliesButton = "_ot-c";
export var wrappingText = "_ot-g";